import { createAsyncThunk } from "@reduxjs/toolkit";
import { getActiveCourts, getDailySchedule } from "./bitrixArenas";
import { mapBitrixDataToArenas } from "./bitrixArenasMapper";
import store from "../store";

import { IArena, IRacket } from "./types";

export const fetchGetArenas = createAsyncThunk<IArena[], string>(
  "rent/fetchGetArenas",
  async (date) => {
    try {
      const state = store.getState();
      const partnerId = (state as any).user?.partnerId;

      const isoDate = `${date}T00:00:00`;

      const [activeCourtsResponse, dailyScheduleResponse] = await Promise.all([
        getActiveCourts(),
        getDailySchedule(partnerId, isoDate),
      ]);

      if (activeCourtsResponse.result && dailyScheduleResponse.result) {
        const arenas = mapBitrixDataToArenas(activeCourtsResponse, dailyScheduleResponse);
        return arenas;
      }
      
      return [];
    } catch (error) {
      throw error;
    }
  }
);

export const fetchGetRackets = createAsyncThunk<IRacket[], string>(
  "rent/fetchGetRackets",
  async (data) => {
    try {
      const { axiosInstance } = await import("../../utils/axios/requestInfo");
      const { api } = await import("../../resources/api");
      const response = await axiosInstance.get(api.rent.rackets.GET_RACKETS(data));
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);
